// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__392r0","legacyBtn":"MutateMid_legacyBtn__3-1gh"};